import api from "./Api";

class SchemaService {
  GetSchema(payload) {
    return api.get("/v1/schema/" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new SchemaService();
